import type { CalendarGroup } from 'owa-graph-schema';
import { getStore } from '../store/store';

export function getCalendarGroupsForUser(
    userIdentity: string
): {
    userCalendarGroups: CalendarGroup[];
    groupCalendarGroups: CalendarGroup[];
    teamsCalendarGroups: CalendarGroup[];
} {
    const calendarStore = getStore();
    const userCalendarGroups = calendarStore.calendarGroups.filter(
        calendarGroup =>
            calendarGroup.calendarGroupId.mailboxInfo.type === 'UserMailbox' &&
            calendarGroup.calendarGroupId.mailboxInfo.userIdentity == userIdentity
    );
    const groupCalendarGroups = calendarStore.calendarGroups.filter(
        calendarGroup =>
            calendarGroup.calendarGroupId.mailboxInfo.type === 'GroupMailbox' &&
            calendarGroup.calendarGroupId.mailboxInfo.userIdentity == userIdentity
    );

    const teamsCalendarGroups = calendarStore.calendarGroups.filter(
        calendarGroup =>
            calendarGroup.calendarGroupId.mailboxInfo.type === 'TeamsMailbox' &&
            calendarGroup.calendarGroupId.mailboxInfo.userIdentity == userIdentity
    );

    return { userCalendarGroups, groupCalendarGroups, teamsCalendarGroups };
}
